module.exports = __webpack_public_path__ + "static/media/wspolpracaco1.c1a1f366.svg";